/**
 * Fetcher Bottle
 * @author Tevin
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FStation extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/station/', '/Home/Gangping/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取气站列表（气站列表）
    getStationList(search, pagination, sorter) {
        const url = this.spellURL('getStationList', '../../lpg/admin/station/list');
        const send = {
            ...search,
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取气站列表（筛选项）
    getStationListAsSelect() {
        const url = this.spellURL('getStationListFilter', '../../lpg/admin/station/stationField');
        const send = {};
        return this.post(url, send).then(res => {
            if (!res) {
                return null;
            }
            return (res.rows || []).map(item => ({
                id: item.id,
                name: item.name,
                stationCode: item.stationCode,
            }));
        });
    }

    // 获取气站信息（数据维护）
    getStationCfg(id) {
        const url = this.spellURL('getStationCfg', 'getStationCfgById');
        return this.post(url, { id });
    }

    // 删除充装记录（数据维护）
    saveDeleteFillRecords(ids) {
        const url = this.spellURL(
            'saveDeleteFillRecords',
            '../../lpg/admin/fillingManagement/GasFilling/deleteFillRecord',
        );
        const send = {
            ids: ids,
        };
        return this.post(url, send);
    }

    // 获取授权气站（筛选项）
    getAuthStationsAsSelect() {
        const url = this.spellURL('getAuthStationsFilter', 'getAuthStation');
        const send = {};
        return this.post(url, send).then(res => {
            if (!res) {
                return null;
            }
            return (res.rows || []).map(item => ({
                id: item.id,
                name: item.name,
            }));
        });
    }

    // [废弃] 获取充装专用气站列表（筛选项）
    getFillStationListAsSelect() {
        const url = this.spellURL('getFillStationListFilter', 'getFillStationField');
        const send = {};
        return this.post(url, send).then(res => {
            if (!res) {
                return null;
            }
            return (res.rows || []).map(item => ({
                id: item.id,
                name: item.station,
            }));
        });
    }

    // 获取气站详情（气站列表）
    getStationDetail(search) {
        const url = this.spellURL('getStationDetail', '../../lpg/admin/station/info');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存气站（气站列表）
    saveStation(station) {
        const url = this.spellURL('saveStation', '../../lpg/admin/station/editWchatStation');
        const send = {
            ...this.transKeyName('underline', this.trimEndsSpace(station)),
            station_id: station.id,
            type: station.id ? 'edit' : 'add',
        };
        delete send.id;
        return this.post(url, send);
    }

    // 获取设备列表（气站设备）
    getEquipmentList(search, pagination, sorter) {
        const url = this.spellURL('getEquipmentList', '../../lpg/admin/station/deviceList');
        const send = {
            ...search,
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取设备详情（气站设备）
    getEquipmentDetail(search) {
        const url = this.spellURL('getEquipmentDetail', 'equipmentInfo');
        const send = {
            ...search,
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存设备（气站设备）
    saveEquipment(equipment) {
        const url = this.spellURL('saveEquipment', '../../lpg/admin/station/editDevice');
        const send = {
            ...this.transKeyName('underline', { ...equipment }),
        };
        return this.post(url, send);
    }

    // 获取气站重瓶列表（气站重瓶列表）
    getStationHeavyBottles(search, pagination, sorter) {
        const url = this.spellURL('getStationHeavyBottles', '../../lpg/admin/station/inventory');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取气站轻瓶列表（气站轻瓶列表）
    getStationLightBottles(search, pagination, sorter) {
        const url = this.spellURL('getStationLightBottles', '../../lpg/admin/station/inventory');
        const send = {
            ...search,
            ...this.transKeyName('underline', search),
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取气站气瓶流转信息（气站重瓶库存、气站轻瓶库存）
    getStationBottleTransit(transit) {
        const url = this.spellURL(
            'getStationBottleTransit',
            '../../lpg/admin/station/inventoryDetail',
        );
        const send = {
            ...this.transKeyName('underline', transit),
        };
        return this.post(url, send);
    }

    // 保存导出气站重瓶库存、轻瓶库存（气站重瓶库存、气站轻瓶库存）
    saveExportStationInventory(search) {
        const url = this.spellURL(
            'saveExportStationInventory',
            '../../lpg/admin/station/exportInventory',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取枪状态（智能枪设备列表）
    getGunStatus(search) {
        const url = this.spellURL(
            'getGunStatus',
            '../../lpg/admin/fillingManagement/GasFilling/getDeviceStatus',
        );
        const send = {
            ...search,
        };
        return this.post(url, send);
    }

    // 获取电子秤列表（智能充装设备）
    getElcEquipment() {
        const url = this.spellURL(
            'getElcEquipment',
            '../../lpg/admin/fillingManagement/GasFilling/getElcEquipment',
        );
        return this.post(url);
    }

    // 保存盒子绑定气站（智能枪设备列表）
    saveBoxBindStation(bindData) {
        const url = this.spellURL(
            'saveBoxBindStation',
            '../../lpg/admin/fillingManagement/GasFilling/bindStationToDevice',
        );
        const send = {
            ...this.transKeyName('underline', bindData),
        };
        return this.post(url, send);
    }

    // 保存充装枪绑定充装员（智能枪设备列表）
    saveGunBindWorker(bindData) {
        const url = this.spellURL(
            'saveGunBindWorker',
            '../../lpg/admin/fillingManagement/GasFilling/bindFillPersonToDevice',
        );
        const send = {
            ...this.transKeyName('underline', bindData),
        };
        return this.post(url, send);
    }

    // 获取设备充装统计（当日充装）
    getDeviceFilling(search) {
        const url = this.spellURL(
            'getDeviceFilling',
            '../../lpg/admin/fillingManagement/GasFilling/getDailyFillHourlyStats',
        );
        const send = {
            ...search,
        };
        return this.post(url, send);
    }

    // 获取充装统计（充装统计）
    getFillingStatistic(search) {
        const url = this.spellURL('getFillingStatistic', 'records_statistics');
        const send = {
            ...search,
            type: 1,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取充装计件（充装计件）
    getFillingPieces(search) {
        const url = this.spellURL('getFillingPieces', 'fillPieceStatistic');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取充装计件明细（充装计件）
    getFillingPieceDetail(search, pagination, sorter) {
        const url = this.spellURL('getFillingPieceDetail', 'fillPieceDetail');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取充前检查列表（充前检查）
    getFillingFrontCheck(search, pagination, sorter) {
        const url = this.spellURL(
            'getFillingFrontCheck',
            '../../lpg/admin/fillingManagement/gasFilling/checkList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
            check_type: 1,
        };
        return this.post(url, send);
    }

    // 保存添加充前检查检测记录（充前检查）
    saveAddFillingFrontCheck(check) {
        const url = this.spellURL(
            'saveAddFillingFrontCheck',
            '../../lpg/admin/fillingManagement/gasFilling/addFillCheckFront',
        );
        const send = {
            ...this.transKeyName('underline', check),
        };
        return this.post(url, send);
    }

    // 保存异步导出充前检查（充前检查）
    saveFillingFrontCheckExport(search) {
        const url = this.spellURL(
            'saveFillingFrontCheckExport',
            '../../lpg/admin/fillingManagement/gasFilling/exportFillCheck',
        );
        const send = {
            ...this.transKeyName('underline', search),
            datetime: search.datetime?.replace(',', ' - '),
            check_type: 1,
        };
        return this.post(url, send);
    }

    // 获取充前、充后导出结果（充前、充后检查）
    getFillingFrontAndBackResult(data) {
        const url = this.spellURL(
            'getFillingFrontAndBackResult',
            '../../lpg/admin/getExportResult',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取充后检查列表（充后检查）
    getFillingBackCheck(search, pagination, sorter) {
        const url = this.spellURL(
            'getFillingBackCheck',
            '../../lpg/admin/fillingManagement/gasFilling/checkList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
            check_type: 2,
        };
        return this.post(url, send);
    }

    // 保存添加充后检查检测记录（充后检查）
    saveAddFillingBackCheck(check) {
        const url = this.spellURL(
            'saveAddFillingBackCheck',
            '../../lpg/admin/fillingManagement/gasFilling/addFillCheckEnd',
        );
        const send = {
            ...this.transKeyName('underline', check),
        };
        return this.post(url, send);
    }

    // 保存异步导出充后检查（充后检查）
    saveFillingBackCheckExport(search) {
        const url = this.spellURL(
            'saveFillingBackCheckExport',
            '../../lpg/admin/fillingManagement/gasFilling/exportFillCheck',
        );
        const send = {
            ...this.transKeyName('underline', search),
            datetime: search.datetime?.replace(',', ' - '),
            check_type: 2,
        };
        return this.post(url, send);
    }

    // 获取充装记录（充装记录）
    getFillingRecordList(search, pagination, sorter) {
        const url = this.spellURL('getFillingRecordList', 'record_list');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 异步导出充装记录全部（充装记录）
    saveExportRecordList(search) {
        const url = this.spellURL('saveExportRecordList', 'exportRecordList');
        const send = {
            ...this.transKeyName('underline', search),
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 保存充装记录监管平台显示百分百（充装记录）
    saveRegulatorPercent(percent) {
        const url = this.spellURL(
            'saveRegulatorPercent',
            '../../lpg/admin/station/filling_record_setting',
        );
        const send = {
            ...this.transKeyName('underline', percent),
        };
        return this.post(url, send);
    }

    // 保存充装记录批量上传（充装记录）
    saveBatchUploadRecords(data) {
        const url = this.spellURL('saveBatchUploadRecords', 'batchUploadFillRecords');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取充装授权列表（充装授权）
    getFillingAuthList(search, pagination, sorter) {
        const url = this.spellURL('getFillingAuthList', 'getFillAuth');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存添加充装授权（充装授权）
    saveAddFillingAuth() {
        const url = this.spellURL('saveAddFillingAuth', 'addFillAuth');
        const send = {};
        return this.post(url, send);
    }

    // 保存申请充装授权（充装授权）
    saveApplyFillingAuth(auth) {
        const url = this.spellURL('saveApplyFillingAuth', 'applyFillAuth');
        const send = {
            ...this.transKeyName('underline', auth),
        };
        return this.post(url, send);
    }

    // 获取审核充装授权时的气站列表（充装授权）
    getAuditFillingStations(audit) {
        const url = this.spellURL('getAuditFillingStations', 'getFillAuthStation');
        const send = {
            ...this.transKeyName('underline', audit),
        };
        return this.post(url, send);
    }

    // 保存充装授权审核结果（充装授权）
    saveAuditFillingAuth(audit) {
        const url = this.spellURL('saveAuditFillingAuth', 'checkFillAuth');
        const send = {
            ...this.transKeyName('underline', audit),
        };
        return this.post(url, send);
    }

    // 保存撤销充装授权（充装授权）
    saveCancelFillingAuth(auth) {
        const url = this.spellURL('saveCancelFillingAuth', 'cancelFillAuth');
        const send = {
            ...this.transKeyName('underline', auth),
        };
        return this.post(url, send);
    }

    // 保存充装授权设置（充装授权）
    saveFillingAuthSetting(setting) {
        const url = this.spellURL('saveFillingAuthSetting', 'updateFillAuthRegister');
        const send = {
            ...this.transKeyName('underline', setting),
        };
        return this.post(url, send);
    }

    // 获取充装记录-导出地址（充装记录）
    getFillingRecordExportUrl(search) {
        const url = this.spellURL('../common/defaultExportUrl', '../Gangping/export_records');
        const send = {
            ...search,
            date: search.date?.replace(',', ' - '),
        };
        if (Fetcher.inDevMod) {
            return this.post(url, send).then(res => ({ url: res.file }));
        } else {
            return Promise.resolve({
                url: this.parseParamUrl(url, send),
            });
        }
    }

    // 获取工业气充前检查（工业气充前检查）
    getIndustryFrontCheck(search, pagination, sorter) {
        const url = this.spellURL('getIndustryFrontCheck', '../Gangping/front_check_industrial');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取工业气过程检查（工业气过程检查）
    getIndustryProcessCheck(search, pagination, sorter) {
        const url = this.spellURL(
            'getIndustryProcessCheck',
            '../Gangping/filling_check_industrial',
        );
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取工业气充后检查（工业气充后检查）
    getIndustryAfterCheck(search, pagination, sorter) {
        const url = this.spellURL('getIndustryAfterCheck', '../Gangping/end_check_industrial');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取工业气充后检查（工业气充后检查）
    getIndustryFillRecord(search, pagination, sorter) {
        const url = this.spellURL('getIndustryFillRecord', '../Gangping/industrial_record_list');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取残重记录（残重记录）
    getResidualRecords(search, pagination, sorter) {
        const url = this.spellURL('getResidualRecords', '../Gangping/residual_record');
        const send = {
            ...this.transKeyName('underline', { ...search }),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取对接平台(气瓶检验记录、充装记录、充前检查、充后检查）
    getExtUploadCfg(searchSet) {
        const { station } = searchSet;
        const url = this.spellURL('getExtUploadCfg', 'getExtUploadCfg');
        return this.post(url, {
            station_id: station,
        });
    }

    // 获取残重分析（残重分析）
    getResidualAnaly(search) {
        const url = this.spellURL('getResidualAnaly', '../User/residual_analy');
        const send = {
            ...this.transKeyName('underline', { ...search }),
        };
        return this.post(url, send);
    }

    // 获取残重分析详情（残重分析）
    getResidualAnalyDetail(search) {
        const url = this.spellURL('getResidualAnalyDetail', '../User/residual_analy_detail');
        const send = {
            ...this.transKeyName('underline', { ...search }),
        };
        return this.post(url, send);
    }

    // 获取气站配置列表（对接配置-表格数据）
    getDockingConfigurationList(search, sorter) {
        const url = this.spellURL(
            'getDockingConfigurationList',
            '../../lpg/admin/station/stationConfigList',
        );
        const send = {
            ...this.transKeyName('underline', { ...search }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取气站对接平台（对接配置-对接平台）
    getPlatformAbutmentConfigList() {
        const url = this.spellURL(
            'getPlatformAbutmentConfigList',
            '../../lpg/admin/station/configList',
        );
        return this.post(url);
    }

    // 保存&修改新增的配置（对接配置）
    savePlatformAbutmentConfigList(params) {
        const url = this.spellURL(
            'savePlatformAbutmentConfigList',
            '../../lpg/admin/station/configSet',
        );
        const send = {
            ...this.transKeyName('underline', { ...params }),
        };
        return this.post(url, send);
    }

    // 删除对接平台配置与气站（对接配置）
    saveDeleteDockingConfiguration(send) {
        const url = this.spellURL(
            'saveDeleteDockingConfiguration',
            '../../lpg/admin/station/configDelete',
        );
        return this.post(url, send);
    }

    // 获取充装预警列表（充装预警）
    getFillingWarningList(search, pagination, sorter) {
        const url = this.spellURL(
            'getFillingWarningList',
            '../../lpg/admin/fillingManagement/gasFilling/alarmList',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
                fillDate: search.fillDate?.replace(',', ' - '),
            }),
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 获取设备配置列表
    getDeviceConfigList(searchSet) {
        const url = this.spellURL('getDeviceConfigList', 'getStationDeviceList');
        const send = {
            ...this.transKeyName('underline', searchSet),
        };
        return this.post(url, send);
    }

    // 保存设备配置
    saveDeviceConfig(data) {
        const url = this.spellURL('saveDeviceConfig', 'operateStationDevice');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取单个配置详情
    getDeviceConfigDetail(data) {
        const url = this.spellURL('getDeviceConfigDetail', 'getDeviceInfo');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取储罐状态
    getAllDeviceMonitorData(data) {
        const url = this.spellURL('getAllDeviceMonitorData', 'getAllDeviceMonitorData');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取信息维护列表（信息维护-山东）
    getInfoMaintenanceList(search, pagination, sorter) {
        const url = this.spellURL(
            'getInfoMaintenanceList' + search.recordType,
            '../../lpg/admin/station/listDataRecord',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存新增信息维护（信息维护-山东）
    saveInfoMaintenance(data) {
        const url = this.spellURL(
            'saveInfoMaintenance',
            '../../lpg/admin/station/createDataRecord',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存新增隐患记录（信息维护-山东）
    saveHazardRecord(data) {
        const url = this.spellURL('saveHazardRecord', '../../lpg/admin/station/createHazardRecord');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取信息维护详情（信息维护-山东）
    getInfoMaintenanceDetail(data) {
        const url = this.spellURL(
            'getInfoMaintenanceDetail' + data.recordType,
            '../../lpg/admin/station/detailDataRecord',
        );
        return this.post(url, data);
    }

    // 保存修改信息维护（信息维护-山东）
    saveUpdateInfoMaintenance(data) {
        const url = this.spellURL(
            'saveUpdateInfoMaintenance',
            '../../lpg/admin/station/updateDataRecord',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 删除信息维护（信息维护-山东）
    saveDelInfoMaintenance(data) {
        const url = this.spellURL(
            'saveDelInfoMaintenance',
            '../../lpg/admin/station/deleteDataRecord',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchStation = new FStation();
